<template>
  <div id="edit_plan_2F">
      <div class="page-header header-filter" data-parallax="true" style="background-image: url('static/img/plan_2F.jpg'); height:50vh; background-position:0px 30%">
          <div class="container">
              <div class="row">
              <div class="col-md-8 ml-auto mr-auto">
                  <div class="brand text-center">
                  <h1>edit_plan_2F</h1>
                  <h3 class="title text-center">Subtitle</h3>
                  </div>
              </div>
              </div>
          </div>
      </div>
      <div class="main">
          <div class="container">
            <div class="section">
              <button class="btn btn-social btn-fill btn-behance" @click="save_data">
                  <span class="material-icons mr-2">save_alt</span> 儲存
              </button>
              <button class="btn btn-social btn-fill btn-tumblr" @click="cancel_edit">
                  <span class="material-icons mr-2">keyboard_return</span> 取消編輯
              </button>
              <button class="btn btn-social btn-fill btn-twitter" @click="add_room">
                <span class="material-icons mr-2">control_point</span> 新增空間
              </button>

              <template v-for="(item, index) in data">
                <table class="table table-bordered" :key="item.id">
                  <thead class="thead-light">
                    <tr>
                      <th style="width:80%">
                        中文空間名稱：<br>
                        <input type="text" class="form-control" v-model="item.room_name_cht" v-if="item.del == 0" placeholder="中文空間名稱">
                        <input type="text" class="form-control text-danger font-italic" v-model="item.room_name_cht" readonly v-else>
                        英文空間名稱：<br>
                        <input type="text" class="form-control" v-model="item.room_name_eng" v-if="item.del == 0" placeholder="英文空間名稱">
                        <input type="text" class="form-control text-danger font-italic" v-model="item.room_name_eng" readonly v-else>
                      </th>
                      <th>
                        <button v-if="item.del == 0" class="btn btn-link btn-twitter" @click="title_del(index)">
                          <span class="material-icons mr-2">remove_circle_outline</span>刪除空間
                        </button>
                        <button v-else class="btn btn-link btn-twitter" @click="title_cancel_del(index)">
                            <span class="material-icons mr-2">delete_sweep</span>取消刪除
                        </button>
                      </th>
                    </tr>
                  </thead>
                  <tr>
                    <td colspan="2">
                      空間編號：<br>
                      <input type="text" class="form-control" v-model="item.room_no" v-if="item.del == 0" placeholder="空間編號">
                      <input type="text" class="form-control text-danger font-italic" v-model="item.room_no" readonly v-else>
                      中文描述：
                      <textarea type="text" class="form-control" v-model="item.description_cht" placeholder="中文描述" rows="2" v-if="item.del == 0"></textarea>
                      <textarea type="text" class="form-control text-danger font-italic" v-model="item.description_cht" rows="2" readonly v-else></textarea>
                      英文描述：
                      <textarea type="text" class="form-control" v-model="item.description_eng" placeholder="英文描述" rows="2" v-if="item.del == 0"></textarea>
                      <textarea type="text" class="form-control text-danger font-italic" v-model="item.description_eng" rows="2" readonly v-else></textarea>
                    </td>
                  </tr>
                  <template v-for="(pic, pic_i) in item.pic_list">
                    <tr :key="pic_i">
                      <td>
                        照片{{ pic_i + 1 }}：
                        <!-- <input type="text" class="form-control" v-model="pic.pic_name" placeholder="照片名稱" v-if="pic.del == 0">
                        <input type="text" class="form-control text-danger font-italic" v-model="pic.pic_name" readonly v-else> -->
                        <template v-if="pic.del == 0">
                          <img style="width:50%;" :src="pic.pic_name" />
                          <label class="btn btn-info">
                            <input type="file" class="custom-file-input" style="display: none;" id="img-upload" accept="image/*" @change="uploadImg($event, index, pic_i)" />
                            <i class="fa fa-photo"></i> 上傳圖片
                          </label>
                        </template>
                      </td>
                      <td>
                        <button v-if="pic.del == 0" class="btn btn-link btn-twitter" @click="list_del(index, pic_i)">
                          <span class="material-icons mr-2">remove_circle_outline</span>刪除照片
                        </button>
                        <button v-else class="btn btn-link btn-twitter" @click="list_cancel_del(index, pic_i)">
                            <span class="material-icons mr-2">delete_sweep</span>取消刪除
                        </button>
                      </td>
                    </tr>
                  </template>
                  <tr>
                    <td colspan="2">
                      <button class="btn btn-social btn-fill btn-twitter" @click="add_pic(index)">
                        <span class="material-icons mr-2">control_point</span>增加照片
                      </button>
                    </td>
                  </tr>
                </table>
              </template>
              
              <button class="btn btn-social btn-fill btn-behance" @click="save_data">
                  <span class="material-icons mr-2">save_alt</span> 儲存
              </button>
              <button class="btn btn-social btn-fill btn-tumblr" @click="cancel_edit">
                  <span class="material-icons mr-2">keyboard_return</span> 取消編輯
              </button>
              <button class="btn btn-social btn-fill btn-twitter" @click="add_room">
                <span class="material-icons mr-2">control_point</span> 新增空間
              </button>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
import axios from "axios";
import EXIF from "exif-js";

export default {
  name: "edit_plan_2F",
  props: [],
  data() {
    return {
      data:[],
      imgFile: [],
      imgNumLimit: 1,
      imgString: [],
    };
  },
  methods: {
    getData: function(){
      var vm = this;
      axios
        .post(`/api/getfloorInfo`,{
          floor: 2
        })
        .then(res => {
          var data = res.data.data;
          // console.log(data)
          for(var i = 0; i < data.length; i++){
            var pic = data[i].img;
            var pic_list = [];
            if(pic != null && pic != '' && pic != 'null'){
              var pic_arr = pic.split('@');
              var pic_len = pic.split('@').length;
              
              if(pic_len > 1){
                for(var j = 0; j < pic_len; j++){
                  pic_list.push({
                    id: j,
                    del: 0,
                    pic_name: pic_arr[j]
                  })
                }
              }
              else{
                pic_list.push({
                    id: 0,
                    del: 0,
                    pic_name: pic
                  })
              }
            }
            

            vm.data.push({
              del: 0,
              id: data[i].id,
              floor: data[i].floor,
              room_no: data[i].room_no,
              room_name_cht: data[i].room_name_cht,
              room_name_eng: data[i].room_name_eng,
              description_cht: data[i].description_cht,
              description_eng: data[i].description_eng,
              pic_list:pic_list
            })
          }
          // vm.data = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    title_del: function(index){
      this.data[index].del = 1
      for(var i = 0; i < this.data[index].pic_list.length; i++){
          this.data[index].pic_list[i].del = 1;
      }
    },
    title_cancel_del: function(index){
      this.data[index].del = 0
      for(var i = 0; i < this.data[index].pic_list.length; i++){
          this.data[index].pic_list[i].del = 0;
      }
    },
    list_del: function(index, pic_i){
      this.data[index].pic_list[pic_i].del = 1;

    },
    list_cancel_del: function(index, pic_i){
      if(this.data[index].del != 1){
        this.data[index].pic_list[pic_i].del = 0;
      }
      else{
        alert('大標題已被標示為刪除');
      }
    },
    add_room: function(){
      this.data.push({
        del: 0,
        id: null,
        room_no: -1,
        floor: 2,
        room_name_cht: null,
        room_name_eng: null,
        description_cht: null,
        description_eng: null,
        pic_list: []
      })
    },
    add_pic: function(index){
      var pic_len = this.data[index].pic_list.length;
      var pic_last_id = 0
      if(pic_len > 0){
        var pic_last_id = this.data[index].pic_list[pic_len - 1].id + 1;
      }

      this.data[index].pic_list.push({
        id: pic_last_id,
        del: 0,
        pic_name: null
      })
      
    },
    uploadImg: function(e, index, sub_i) {      
      let tag = e.target;
      let fileList = tag.files;
      let imgNum = fileList.length;
      let _this = this;
      _this.imgString = [];   //圖片資料清零
      _this.imgFile = [];     //圖片資料清零
      if (imgNum > this.imgNumLimit) {
        alert("一次最多上傳" + this.imgNumLimit + "張圖片！");
        return;
      }
      var Orientation;
      for (let i = 0; i < imgNum; i++) {
        _this.imgFile.push(fileList[i]);
        EXIF.getData(fileList[i], function() {
          Orientation = EXIF.getTag(fileList[i], "Orientation");
        });
        // file to base64
        let reader = new FileReader();
        reader.readAsDataURL(fileList[i]);
        reader.onload = function() {
          var oReader = new FileReader();
          oReader.onload = function(e) {
            var image = new Image();
            image.src = e.target.result;
            image.onload = function() {

              var expectWidth = this.naturalWidth;
              var expectHeight = this.naturalHeight;
              if (
                this.naturalWidth > this.naturalHeight &&
                this.naturalWidth > 800
              ) {
                expectWidth = 800;
                expectHeight =
                  (expectWidth * this.naturalHeight) / this.naturalWidth;
              } else if (
                this.naturalHeight > this.naturalWidth &&
                this.naturalHeight > 1200
              ) {
                expectHeight = 1200;
                expectWidth =
                  (expectHeight * this.naturalWidth) / this.naturalHeight;
              }
              var canvas = document.createElement("canvas");
              var ctx = canvas.getContext("2d");
              canvas.width = expectWidth;
              canvas.height = expectHeight;
              ctx.drawImage(this, 0, 0, expectWidth, expectHeight);

              var base64 = null;

              base64 = canvas.toDataURL("image/jpeg", 0.8);
              _this.imgString.push({ src: base64 });

              
              _this.data[index].pic_list[sub_i].pic_name = _this.imgString[0].src;
              
              // console.log(JSON.stringify(_this.imgString));
            };
          };
          oReader.readAsDataURL(fileList[i]);
        };
      }
    },
    async save_data(){
      var vm = this;
      var save_data = [];

      for(var i = 0; i < vm.data.length; i++){
        var pic_list = vm.data[i].pic_list;
        var pic_str = '';
        
        pic_list.forEach(function(item, idx){
          if(item.del == 0){
            if (idx === pic_list.length - 1){ 
              pic_str += item.pic_name;
            }
            else{
              pic_str += item.pic_name + '@';
            }
          }
        })
        
        save_data.push({
          id: vm.data[i].id,
          floor: vm.data[i].floor,
          img: pic_str,
          room_no: vm.data[i].room_no,
          room_name_cht: vm.data[i].room_name_cht,
          room_name_eng: vm.data[i].room_name_eng,
          description_cht: vm.data[i].description_cht,
          description_eng: vm.data[i].description_eng,
          title_del: vm.data[i].del
        })
        await vm.savefloor({
          id: vm.data[i].id,
          floor: vm.data[i].floor,
          img: pic_str,
          room_no: vm.data[i].room_no,
          room_name_cht: vm.data[i].room_name_cht,
          room_name_eng: vm.data[i].room_name_eng,
          description_cht: vm.data[i].description_cht,
          description_eng: vm.data[i].description_eng,
          title_del: vm.data[i].del
        })
        
      }
      vm.$router.push("/about/plan_2F");
      
      // axios
      //   .post(`${process.env.API_PATH}/api/savefloorInfo`,save_data)
      //   .then(res => {
      //     // console.log(res);
      //     if(res.status == 200)
      //         vm.$router.push("/about/plan_2F");
      //   })
      //   .catch(err => {
      //     console.log(err);
      //   });
    }, 
    // 儲存
    async savefloor(save_data){
        var vm = this;
                
        return new Promise(resolve => {
            axios
              .post(`/api/savefloorInfo`,save_data)
              .then(res => {                  
                  resolve();  // 表示完成
              })
              .catch(err => {
                  console.log(err);
              });
        });
    },
    cancel_edit: function(){
      this.$router.push("/about/plan_2F");
    },
  },
  filters: {
    imgUrl: function(value) {
      if(value != null || value != 'null' || value != ''){
        value = "/static/img/about/" + value + ".jpg";
      }
      else{
        value = "/static/img/image_placeholder.jpg";
      }
      
      return value;
    }
  },
  computed: {},
  created() {
    this.getData();
  },
  mounted() {
  },
  components: {},
  watch: {}
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/about/edit_plan_2F.vue